import { reducers_default as reducers_default$3 } from './chunk-RYIMO53E.mjs';
import { reducers_default as reducers_default$2 } from './chunk-SUDIZNAH.mjs';
import { reducers_default as reducers_default$5 } from './chunk-RBNWGQ46.mjs';
import { reducers_default as reducers_default$1 } from './chunk-NEC4FB5C.mjs';
import { reducers_default } from './chunk-UMRXZDPH.mjs';
import { reducer_default } from './chunk-AGNBMAAF.mjs';
import { reducers_default as reducers_default$4 } from './chunk-VAWSPTNR.mjs';
import { reducers_default as reducers_default$6 } from './chunk-C4TCBMKL.mjs';
import { combineReducers } from 'redux';

var NO_MODIFIER_TAG = {
  id: 0,
  locationId: 0,
  modifierTagId: 0,
  posName: "NO",
  active: true,
  sortPriority: 0,
  organizationId: 0,
  createdByLocationId: 0,
  name: "NO",
  checkName: "NO",
  tagPosition: "before" /* BEFORE */,
  textColor: "textWhite",
  backgroundColor: "persistentSemanticRed",
  isSpecial: true,
  menuTypeIds: null
};
var GET_NO_MODIFIER_TAG_SELECTED = () => ({
  isSpecial: true,
  modifierTagId: 0,
  name: "NO",
  checkName: "NO",
  tagPosition: "before" /* BEFORE */
});
var NO_MODIFIER_TAG_POS_NAME = "NO";
var LITE_MODIFIER_TAG_POS_NAME = "LIGHT";
var EXTRA_MODIFIER_TAG_POS_NAME = "EXTRA";
var ON_SIDE_MODIFIER_TAG_POS_NAME = "ON SIDE";
var COURSE_INITIAL_STATE = {
  active: true,
  name: "",
  posName: "",
  kitchenName: "",
  sortPriority: 0,
  triggerTime: 0,
  organizationId: 0,
  locationId: 0,
  id: 0,
  courseId: 0
};
var REGISTER_COURSE_TIME_INITIAL_STATE = {
  timeTriggered: null,
  timeSentToKitchen: null,
  courseName: "",
  isActive: true,
  courseId: 0,
  sortPriority: 0,
  triggerTime: 0,
  type: "predefined" /* PREDEFINED */
};
var reducers_default8 = combineReducers({
  licenseSettings: reducers_default,
  selectedMode: reducers_default$1,
  changeData: reducer_default,
  versions: reducers_default$2,
  master: reducers_default$3,
  location: reducers_default$4,
  remoteLocation: reducers_default$5,
  breadCrumb: reducers_default$6
});

export { COURSE_INITIAL_STATE, EXTRA_MODIFIER_TAG_POS_NAME, GET_NO_MODIFIER_TAG_SELECTED, LITE_MODIFIER_TAG_POS_NAME, NO_MODIFIER_TAG, NO_MODIFIER_TAG_POS_NAME, ON_SIDE_MODIFIER_TAG_POS_NAME, REGISTER_COURSE_TIME_INITIAL_STATE, reducers_default8 as reducers_default };
